var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pdf-wrapper", class: { sm: _vm.$wf.isSmDown } },
    [
      _vm.fetching
        ? _c(
            "div",
            {
              staticClass: "spinner-overlay",
              style: { backgroundColor: "#0000" },
            },
            [_c("app-delayed-progress")],
            1
          )
        : _vm._e(),
      !_vm.useImages && _vm.pdfViewer.getURL()
        ? _c("iframe", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.fetching,
                expression: "!fetching",
              },
            ],
            ref: "iframe",
            staticClass: "pdf",
            attrs: { id: "pdf-frame", src: _vm.pdfViewer.getURL() },
          })
        : _vm._e(),
      _c(
        "w-scroll-view",
        { staticClass: "image-container", attrs: { tag: "div" } },
        _vm._l(_vm.pdfViewer.getImageUrls(), function (url, i) {
          return _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.fetching,
                  expression: "!fetching",
                },
              ],
              key: i,
              staticClass: "image",
            },
            [_c("img", { attrs: { src: url, alt: `Pdf pagina ${i + 1}` } })]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }